import React, { useEffect } from "react";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import { Col, Form, Input, Row } from "antd";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import {
  convertFileToBase64,
  showNotitfication,
} from "../../../../components/utils/utils";
import {
  toCancelProgramRequest,
  toGetProgramRequests,
} from "../../../../apis/actions/programs.actions";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../apis/store";
import { setResIds, setResModel } from "../../../../apis/slices/ratingSlice";
interface Props {
  isModalVisible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  programId: any;
}
const { TextArea } = Input;

const CancelProgramRequest = ({
  isModalVisible,
  setIsModalVisible,
  programId,
}: Props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    form.resetFields();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalVisible]);

  const handleFileChange = async (fileList: any[]) => {
    const attachments = [];
    for (const fileItem of fileList) {
      const file = fileItem?.originFileObj;
      if (file) {
        try {
          const base64 = await convertFileToBase64(file);
          const imageData = {
            filename: file.name,
            data: base64,
          };
          attachments.push(imageData);
          form.setFieldsValue({
            attachment_ids: attachments,
          });
        } catch (error) {
          console.error("Error converting file to Base64:", error);
        }
      }
    }
  };
  const onFinish = async () => {
    try {
      await form.validateFields();

      const FormValues = form.getFieldsValue();
      const programFormData = {
        reason: FormValues.reason,
        attachment_ids: FormValues.attachment_ids ?? [],
        program_application_id: programId,
      };
      dispatch(toCancelProgramRequest(programFormData)).then((result: any) => {
        const program = result?.payload?.data?.result;
        if (program?.code === 200) {
          dispatch(setResModel(program?.res_model));
          dispatch(setResIds([program?.cancel_application_request_id]));
          showNotitfication(program?.message, "success", dispatch);
          dispatch(toGetProgramRequests({ limit: 8, page: 1 }));
          setIsModalVisible(false);
        } else {
          showNotitfication(program?.message, "error");
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <ModalComponent
      title=""
      open={isModalVisible}
      onClose={() => setIsModalVisible(false)}
      closeOnOutsideClick={true}
      width={800}
      modalStyle={{ top: 200 }}
    >
      <Form form={form} layout="vertical">
        <Row justify={"center"}>
          <p className="takaful--confirm-logout">طلب إلغاء الترشح على برنامج</p>
        </Row>
        <Row
          gutter={16}
          justify={"center"}
          style={{ paddingTop: "2rem" }}
          className={`takaful--content-profile-box1 takaful--content-select`}
        >
          <Col span={24} className="takaful--content-profile-col">
            <Form.Item
              name="reason"
              label="السبب:"
              layout="horizontal"
              wrapperCol={{
                xxl: 19,
                xl: 19,
                lg: 19,
                md: 19,
                sm: 19,
                xs: 24,
              }}
              labelAlign="left"
              labelCol={{
                className: "takaful--label-style",
                xxl: 5,
                xl: 5,
                lg: 5,
                md: 5,
                sm: 5,
                xs: 24,
              }}
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
            >
              <TextArea />
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={16}
          justify={"center"}
          className={`takaful--content-profile-box1`}
        >
          <Col
            xxl={5}
            xl={5}
            lg={5}
            md={5}
            sm={5}
            xs={24}
            className="takaful--content-profile-col"
          >
            <p className="takaful--content-services-request-p"> مرفقات:</p>
          </Col>
          <Col
            xxl={19}
            xl={19}
            lg={19}
            md={19}
            sm={19}
            xs={24}
            className="takaful--content-profile-col"
          >
            <Form.Item
              name="attachment_ids"
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <UploadInput
                text="إرفاق أي مستندات تدعم الطلب"
                icon={<UploadOutlined />}
                multiple={true}
                onChange={handleFileChange}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify={"end"} dir="rtl" style={{ width: "100%" }}>
          <Col xxl={4} xl={4} lg={4} md={4} sm={9} xs={9}>
            <PrimaryButton
              style={{ width: "100%" }}
              onClick={() => {
                onFinish();
              }}
              title="إلغاء"
            />
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default CancelProgramRequest;
